document.addEventListener('DOMContentLoaded', function () {
    function showfulldesc() {
        var dots = document.getElementById("less");
        var moreText = document.getElementById("more");
        var btnText = document.getElementById("myBtnshowdes");

        if (dots.style.display === "none") {
            dots.style.display = "inline";
            btnText.innerHTML = "Read More"; 
            moreText.style.display = "none";
        } else {
            dots.style.display = "none";
            btnText.innerHTML = "Read Less"; 
            moreText.style.display = "inline";
        }
    }


    var $galleryDesktop = $('.testimonial-gallery-wrapper__desktop');
    var $galleryMobile = $('.testimonial-gallery-wrapper__mobile');
    var $desktopSlides = $galleryDesktop.find('.testimonial-gallery-image');
    var $mobileSlides = $galleryMobile.find('.testimonial-gallery-image');

    if ($desktopSlides.length > 6) {
        $galleryDesktop.find('.testimonial-gallery-inner').slick({
            variableWidth: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: true,
            dots: false,
            infinite: true,
            speed: 500,
            pauseOnHover: true
        });
    } else {
        $galleryDesktop.find('.testimonial-gallery-inner').addClass('gallery-flex')
    }

    if ($mobileSlides.length > 5) {
        $galleryMobile.find('.testimonial-gallery-inner').slick({
            variableWidth: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: true,
            dots: false,
            infinite: true,
            speed: 500,
            pauseOnHover: true,
            responsive: [
                {
                breakpoint: 640,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
                },
            ]
        });
    } else {
        $galleryMobile.find('.testimonial-gallery-inner').addClass('gallery-flex')
    }

    // Open modal on image click
    $('.testimonial-img').on('click', function() {
        var imgSrc = $(this).attr('src');
        $('#gallery-modal-image').attr('src', imgSrc);
        $('#gallery-modal').fadeIn();
    });

    // Close modal
    $('.gallery-close-modal, #gallery-modal').on('click', function(e) {
        if (e.target !== this) return; // allow image clicks without closing
        $('#gallery-modal').fadeOut();
    });
    
    $('.slick-slider_image').slick({
        slidesToShow: 1,
        asNavFor: '.thumb_slider_add',
        slidesToScroll: 1,
        arrows:true,
        dots:false,
        speed: 600,
        infinite: true,
        autoplaySpeed: 2000,
        autoplay:false,
        responsive: [
            {
            breakpoint: 767,
            settings: {
                variableWidth: true,
                centerMode:true
            }
            }
        ]
    });

    $('.new-slick-slider_image').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:true,
        dots:false,
        speed: 600,
        infinite: false,
        autoplaySpeed: 2000,
        autoplay:false,
        responsive: [
        {
            breakpoint: 767,
            settings: {
                infinite: true
            }
        }
    ]
    });

    var slider = $('.thumb_slider_add')
    
    slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slick-slider_image',
        dots: false,
        // centerMode: true,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true

    });

    document.addEventListener('variant:changed', function(event) {
        const variant = event.detail.variant;
        const media = variant.featured_media;

        if (media !== null && media !== undefined) {
            const imageId = media.id;
            const slides = document.querySelectorAll(`.slider-thumbnail-image[data-media-id="${imageId}"]`);

            slides.forEach(slide => {
                const thumbnailSlide = slide.closest('.slick-slide');
                if (!thumbnailSlide.classList.contains('slick-cloned')) {
                const slideIndex = thumbnailSlide.dataset.slickIndex;
                slider.slick('slickGoTo', slideIndex);
                }
            });
        }
    });

    $('.product_img, .RoundButton').click(function(){
        $('.new_popup').addClass('intro');
    });
    
    $('.new_slider_img, .close').click(function(){
        $('.new_popup').removeClass('intro'); 
    });
});